import PicViewer from './pic-viewer.vue';
export default PicViewer;
